export default __webpack_public_path__ + "static/media/completed-order-3.31a20898.gif";